import React, { PureComponent } from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { Form, Field } from 'react-final-form';
import { Divider, Checkbox, Select } from 'antd';
import EditSupplierHOC from './EditSupplierCapsHOC';
import NFButton from '../../components/primitives/NFButton';

import {
  SupplierProfileFieldsLeft,
  SupplierProfileFieldsRight,
  ClassificationsAndCapsFieldsLeft,
  ClassificationsAndCapsFieldsRight,
} from './formConfig';
import {
  // weightRange,
  Aluminum,
  copper,
  Iron,
  MMC,
  other,
  steel,
} from '../../config/SupplierSearchOptions/MaterialOptions';

const { Option } = Select;

class EditSupplierCaps extends PureComponent {
  static initialState = {
    isLoading: true,
  };
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onAlloyChange: PropTypes.func.isRequired,
    onMaterialChange: PropTypes.func.isRequired,
    setInitalValuesForAlloy: PropTypes.func.isRequired,

    // .shape({})
    initialValues: PropTypes.object,
  };

  static defaultProps = {
    initialValues: {},
  };

  createOptions = (value, showSelectedKeys = false) => {
    let obj;
    let materialValue;
    switch (value) {
      case 'Aluminum':
        obj = Aluminum;
        materialValue = 'aluminum';
        break;
      case 'Copper':
        obj = copper;
        materialValue = 'copper';

        break;
      case 'Iron':
        obj = Iron;
        materialValue = 'iron';

        break;
      case 'Other Non-Ferrous':
        obj = other;
        materialValue = 'other';
        break;
      case 'Steel':
        obj = steel;
        materialValue = 'steel';

        break;
      case 'Metal Matrix Composites':
        obj = MMC;
        materialValue = 'mmc';

        break;

      default:
        break;
    }

    const objKeys = Object.values(obj);

    const options = objKeys.map(key => <Option key={key}>{key}</Option>);
    if (showSelectedKeys) {
      const array = this.props.initialValues.alloy.filter(alloy => obj[alloy]);
      this.props.setInitalValuesForAlloy(materialValue, array);

      return array;
    }
    return options;
  };

  render() {
    const MaterialLeft = [
      'Aluminum',
      'Copper',
      'Iron',
      'Cobalt',
      'Copper (Brass/Bronze)',
      'Lead',
      'Magnesium',
    ];

    const MaterialRight = [
      'Metal Matrix Composites',
      'Nickel',
      'Other Non-Ferrous',
      'Steel',
      'Superalloys',
      'Titanium',
      'Zinc',
    ];

    const { onSubmit, initialValues, onMaterialChange } = this.props;
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Edit Supplier Capabilities Page</title>
        </Helmet>


        {/* <div
          style={{
            background: 'rgba(0,0,0, .7)',
            position: 'absolute',
            height: '100%',
            width: '100%',
            zIndex: '1000',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div style={{ paddingTop: '16px' }}>
            <img src={icon} alt="ICON" />{' '}
          </div>
          <div>
            <h2 style={{ color: 'white', padding: '32px', fontSize: '27px' }}>
              This Service Is temporarily Unavailable
            </h2>
          </div>
        </div> */}

        <Form
          onSubmit={onSubmit}
          initialValues={initialValues}
          render={({
            handleSubmit,
            values,
            //  pristine, invalid, submitting
          }) => {
            console.log(initialValues)
            return <form className="nf-new-org-form" onSubmit={handleSubmit}>
              <div>
                <br /> {/* Supplier Profile Information */}
                <Divider orientation="left">
                  Supplier Profile Information
                </Divider>
                <br />
                <Row>
                  <Col>
                    <div className="icon-sup-prof-fields-left">
                      {SupplierProfileFieldsLeft.map(fieldConfig => (
                        <Field key={fieldConfig.name} {...fieldConfig} />
                      ))}
                    </div>
                  </Col>
                  <Divider type="vertical" />
                  <Col>
                    {SupplierProfileFieldsRight.map(fieldConfig => (
                      <Field key={fieldConfig.name} {...fieldConfig} />
                    ))}
                  </Col>
                </Row>
                <br /> {/* Supplier Classifications and Capabilities */}
                <Divider orientation="left">Supplier Capabilities</Divider>
                <br />
                <Row>
                  <Col>
                    {ClassificationsAndCapsFieldsLeft.map(fieldConfig => (
                      <Field key={fieldConfig.name} {...fieldConfig} />
                    ))}
                  </Col>
                  <Col>
                    {ClassificationsAndCapsFieldsRight.map(fieldConfig => {
                      console.log(fieldConfig)
                      return <Field key={fieldConfig.name} {...fieldConfig} />
                    })}
                  </Col>
                </Row>
                <br /> {/* Supplier Classifications and Capabilities */}
                <Divider orientation="left">Materials</Divider>
                <br />
                <Row>
                  <Col>
                    <div className="icon-sup-prof-fields-left">
                      <Checkbox.Group
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                        value={initialValues.material}
                        onChange={materials =>
                          onMaterialChange(materials, 'left', values)
                        }
                      >
                        {MaterialLeft.map(material => {
                          if (
                            material === 'Copper' ||
                            material === 'Iron' ||
                            material === 'Aluminum' ||
                            material === 'Steel' ||
                            material === 'Other Non-Ferrous'
                          ) {
                            return (
                              <Row>
                                <Col md={4}>
                                  <Checkbox
                                    style={{
                                      marginLeft: '8px',
                                    }}
                                    value={material}
                                  >
                                    {material}
                                  </Checkbox>
                                </Col>

                                <Col md={7}>
                                  <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Please select"
                                    onChange={alloy =>
                                      this.props.onAlloyChange(
                                        alloy,
                                        material,
                                        values,
                                      )
                                    }
                                    value={this.createOptions(material, true)}
                                  >
                                    {this.createOptions(material)}
                                  </Select>
                                </Col>
                              </Row>
                            );
                          }
                          return (
                            <Row>
                              <Col md={6}>
                                <Checkbox
                                  style={{
                                    marginLeft: '8px',
                                    height: '32px',
                                  }}
                                  value={material}
                                >
                                  {material}
                                </Checkbox>
                              </Col>
                            </Row>
                          );
                        })}
                      </Checkbox.Group>
                    </div>
                  </Col>
                  <Col>
                    <div className="icon-sup-prof-fields-left">
                      <Checkbox.Group
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                        value={initialValues.material}
                        onChange={material =>
                          onMaterialChange(material, 'right', values)
                        }
                      >
                        {MaterialRight.map(material => {
                          if (
                            material === 'Copper' ||
                            material === 'Iron' ||
                            material === 'Aluminum' ||
                            material === 'Other Non-Ferrous' ||
                            material === 'Steel' ||
                            material === 'Metal Matrix Composites'
                          ) {
                            return (
                              <div
                                style={{
                                  width: '100%',
                                  display: 'flex',
                                  marginTop: '4px',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <Checkbox
                                  style={{
                                    marginLeft: '8px',
                                  }}
                                  value={material}
                                >
                                  {material}
                                </Checkbox>

                                <div style={{ width: '50%' }}>
                                  <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Please select"
                                    onChange={alloy =>
                                      this.props.onAlloyChange(
                                        alloy,
                                        material,
                                        values,
                                      )
                                    }
                                    value={this.createOptions(material, true)}
                                  >
                                    {this.createOptions(material)}
                                  </Select>
                                </div>
                              </div>
                            );
                          }
                          return (
                            <Checkbox
                              style={{
                                marginLeft: '8px',
                                height: '32px',
                              }}
                              value={material}
                            >
                              {material}
                            </Checkbox>
                          );
                        })}
                      </Checkbox.Group>
                    </div>
                  </Col>
                </Row>
                <NFButton
                  className="nf-button--form nf-button--orange"
                  type="submit"
                // disabled={pristine || submitting || invalid}
                >
                  Save Changes
                </NFButton>
              </div>
            </form>
          }}
        />
      </div>
    );
  }
}

export default EditSupplierHOC(EditSupplierCaps);


















// WEBPACK FOOTER //
// ./src/components/EditSupplierCaps/EditSupplierCaps.jsx